function normalizarTextoParaBusca (texto) {
  return String(texto || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
}

export function operacaoEhTravamentoUnilateral (operacao) {
  return operacao === 'lockUnilateral'
}

export function filtrarEmpregadosPorNome (empregados, busca) {
  const buscaNormalizada = normalizarTextoParaBusca(busca)
  if (!buscaNormalizada) return empregados

  return empregados.filter(empregado =>
    normalizarTextoParaBusca(empregado.name).includes(buscaNormalizada)
  )
}

export function normalizarEmpregadosParaSelecao (empregados, empregadosConhecidos = []) {
  const empregadosPorId = new Map(
    empregadosConhecidos.map(empregado => [String(empregado.id), empregado])
  )

  return empregados.map(empregado => {
    if (typeof empregado === 'object') return empregado

    return empregadosPorId.get(String(empregado)) || {
      id: empregado,
      name: String(empregado)
    }
  })
}

export function obterEmpregadosExcecoes (empregados, empregadosSelecionados) {
  const idsSelecionados = new Set(empregadosSelecionados.map(String))
  return empregados
    .filter(empregado => !idsSelecionados.has(String(empregado.id)))
    .map(empregado => empregado.id)
}
